import React from 'react'

import Footer from '../../components/footer/Footer'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Navbar from '../Instructor/HomePage/Navbar'

const Home = () => {
  const path = useLocation()


  return (
    <div>
      {/* <TopHeader /> */}
      {/* <AppHeader /> */}
     
      {path?.pathname !== '/' ?  
        
       <Navbar />
      : null}
      <Outlet />
      <Footer />
    </div>
  )
}

export default Home
